<template>
  <div class="form-step">
    <div class="section-header">
      <h5 class="section-title">EDCTP Fellow Information</h5>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label">EDCTP Fellow</label>
        <input
          type="text"
          class="form-control"
          v-model="fellowship.fellow"
          @input="emitUpdate"
          placeholder="Enter fellow name"
          readonly
          style="background: #e9ecef"
        >
      </div>
      <div class="col-md-6">
        <label class="form-label">Gender</label>
        <select
          class="form-select"
          v-model="fellowship.gender"
          @change="emitUpdate"
          disabled
          style="background: #e9ecef"
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="other">Other</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label class="form-label">EDCTP Programme</label>
        <input
          type="text"
          class="form-control"
          :value="programmeLabel"
          readonly
          style="background: #e9ecef"
        />
      </div>
      <div class="col-md-4">
        <label class="form-label">EDCTP Call</label>
        <input
          type="text"
          class="form-control"
          :value="callLabel"
          readonly
          style="background: #e9ecef"
        />
      </div>
      <div class="col-md-4">
        <label class="form-label">EDCTP Call Year</label>
        <input
          type="text"
          class="form-control"
          :value="callYearLabel"
          placeholder="Enter call year"
          readonly
          style="background: #e9ecef"
        >
      </div>
    </div>
    <div class="section-header">
      <h5 class="section-title">Fellowship Information</h5>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label">EDCTP Title</label>
        <input
          type="text"
          class="form-control"
          v-model="fellowship.title"
          @input="emitUpdate"
          placeholder="Enter project title"
          readonly
          style="background: #e9ecef"
        >
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label class="form-label">EDCTP Project Code</label>
        <input
          type="text"
          class="form-control"
          v-model="fellowship.projectCode"
          @input="emitUpdate"
          placeholder="Enter project code"
          readonly
          style="background: #e9ecef"
        >
      </div>
      <div class="col-md-4">
        <label class="form-label">Start Date</label>
        <input
          type="date"
          class="form-control"
          v-model="fellowship.startDate"
          @input="emitUpdate"
          readonly
          style="background: #e9ecef"
        >
      </div>
      <div class="col-md-4">
        <label class="form-label">End Date</label>
        <input
          type="date"
          class="form-control"
          v-model="fellowship.endDate"
          @input="emitUpdate"
          readonly
          style="background: #e9ecef"
        >
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label class="form-label">Objectives</label>
        <textarea
          class="form-control"
          rows="4"
          v-model="fellowship.objectives"
          @input="emitUpdate"
          placeholder="Enter objectives..."
          readonly
          style="background: #e9ecef"
        ></textarea>
      </div>
      <div class="col-md-4">
        <label class="form-label">Study Design</label>
        <textarea
          class="form-control"
          rows="4"
          v-model="fellowship.studyDesign"
          @input="emitUpdate"
          placeholder="Enter study design..."
          readonly
          style="background: #e9ecef"
        ></textarea>
      </div>
      <div class="col-md-4">
        <label class="form-label">Project Summary</label>
        <textarea
          class="form-control"
          rows="4"
          v-model="fellowship.projectSummary"
          @input="emitUpdate"
          placeholder="Enter project summary..."
          readonly
          style="background: #e9ecef"
        ></textarea>
      </div>
    </div>

    <!-- Collaborators Section -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <h5 class="section-title mb-0">Host Organisation</h5>
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="addCollaborator"
      >
        <i class="bi bi-plus me-2"></i>Add Organisation
      </button>
    </div>
    <div v-for="(collaborator, index) in collaborators" :key="'collab-' + index" class="border rounded p-3 mb-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="mb-0">Organisation {{ index + 1 }}</h6>
        <button
          v-if="collaborators.length > 1"
          type="button"
          class="btn btn-sm btn-danger"
          @click="removeCollaborator(index)"
          style="border: 1px solid #ff3e1d; color: #ff3e1d; background: transparent"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label class="form-label">Department</label>
          <input
            type="text"
            class="form-control"
            v-model="collaborator.department"
            @input="emitUpdate"
            placeholder="Enter department"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">Institution</label>
          <input
            type="text"
            class="form-control"
            v-model="collaborator.institution"
            @input="emitUpdate"
            placeholder="Enter institution"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">Country</label>
          <select
            class="form-select"
            v-model="collaborator.country"
            @change="emitUpdate"
          >
            <option value="">Select Country</option>
              <option v-for="country in internationalCountries" :key="country.value" :value="country.value">
              {{ country.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Participants Section -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <h5 class="section-title mb-0">Participants</h5>
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="addParticipant"
      >
        <i class="bi bi-plus me-2"></i>Add Participant
      </button>
    </div>
    <div v-for="(participant, index) in participants" :key="'part-' + index" class="border rounded p-3 mb-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="mb-0">Participant {{ index + 1 }}</h6>
        <button
          v-if="participants.length > 1"
          type="button"
          class="btn btn-sm btn-danger"
          @click="removeParticipant(index)"
          style="border: 1px solid #ff3e1d; color: #ff3e1d; background: transparent"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label class="form-label">Department</label>
          <input
            type="text"
            class="form-control"
            v-model="participant.department"
            @input="emitUpdate"
            placeholder="Enter department"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">Institution</label>
          <input
            type="text"
            class="form-control"
            v-model="participant.institution"
            @input="emitUpdate"
            placeholder="Enter institution"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">Country</label>
          <select
            class="form-select"
            v-model="participant.country"
            @change="emitUpdate"
          >
            <option value="">Select Country</option>
              <option v-for="country in internationalCountries" :key="country.value" :value="country.value">
              {{ country.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Students Section -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <h5 class="section-title mb-0">Students Supervised</h5>
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="addStudent"
      >
        <i class="bi bi-plus me-2"></i>Add Student
      </button>
    </div>
    <div v-for="(student, index) in students" :key="'student-' + index" class="border rounded p-3 mb-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="mb-0">Student {{ index + 1 }}</h6>
        <button
          v-if="students.length > 1"
          type="button"
          class="btn btn-sm btn-danger"
          @click="removeStudent(index)"
          style="border: 1px solid #ff3e1d; color: #ff3e1d; background: transparent"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label class="form-label">Type</label>
          <input
            type="text"
            class="form-control"
            v-model="student.type"
            @input="emitUpdate"
            placeholder="Enter type"
          >
        </div>
        <div class="col-md-3">
          <label class="form-label">Name</label>
          <input
            type="text"
            class="form-control"
            v-model="student.name"
            @input="emitUpdate"
            placeholder="Enter student name"
          >
        </div>
        <div class="col-md-3">
          <label class="form-label">Title</label>
          <select
            class="form-select"
            v-model="student.title"
            @change="emitUpdate"
          >
            <option value="">Select Title</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Ms">Ms</option>
            <option value="Dr">Dr</option>
            <option value="Associate Professor">Associate Professor</option>
            <option value="Professor">Professor</option>
            <option value="Public">Public</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Country</label>
          <select
            class="form-select"
            v-model="student.country"
            @change="emitUpdate"
          >
            <option value="">Select Country</option>
            <option v-for="country in africanCountries" :key="country.value" :value="country.value">
              {{ country.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6">
          <label class="form-label">University</label>
          <input
            type="text"
            class="form-control"
            v-model="student.university"
            @input="emitUpdate"
            placeholder="Enter university name"
          >
        </div>
        <div class="col-md-3">
          <label class="form-label">Start Date</label>
          <input
            type="date"
            class="form-control"
            v-model="student.startDate"
            @input="emitUpdate"
          >
        </div>
        <div class="col-md-3">
          <label class="form-label">End Date</label>
          <input
            type="date"
            class="form-control"
            v-model="student.endDate"
            @input="emitUpdate"
          >
        </div>
      </div>
    </div>

    <!-- Sites Section -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <h5 class="section-title mb-0">Sites</h5>
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="addSite"
      >
        <i class="bi bi-plus me-2"></i>Add Site
      </button>
    </div>
    <div v-for="(site, index) in sites" :key="'site-' + index" class="border rounded p-3 mb-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="mb-0">Site {{ index + 1 }}</h6>
        <button
          v-if="sites.length > 1"
          type="button"
          class="btn btn-sm btn-danger"
          @click="removeSite(index)"
          style="border: 1px solid #ff3e1d; color: #ff3e1d; background: transparent"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="form-label">Name</label>
          <input
            type="text"
            class="form-control"
            v-model="site.name"
            @input="emitUpdate"
            placeholder="Enter site name"
          >
        </div>
      </div>
    </div>

    <!-- PhD Study Section -->
    <div class="section-header">
      <h5 class="section-title">PhD Study by Fellow</h5>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label">Title</label>
        <input
          type="text"
          class="form-control"
          v-model="phdStudy.title"
          @input="emitUpdate"
          placeholder="Enter PhD study title"
        >
      </div>
      <div class="col-md-6">
        <label class="form-label">University</label>
        <input
          type="text"
          class="form-control"
          v-model="phdStudy.university"
          @input="emitUpdate"
          placeholder="Enter university name"
        >
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label">Start Date</label>
        <input
          type="date"
          class="form-control"
          v-model="phdStudy.startDate"
          @input="emitUpdate"
        >
      </div>
      <div class="col-md-3">
        <label class="form-label">End Date</label>
        <input
          type="date"
          class="form-control"
          v-model="phdStudy.endDate"
          @input="emitUpdate"
        >
      </div>
      <div class="col-md-3">
        <label class="form-label">Number of subjects</label>
        <input
          type="number"
          class="form-control"
          v-model="phdStudy.subjects"
          @input="emitUpdate"
          placeholder="Enter number of subjects"
        >
      </div>
      <div class="col-md-3">
        <label class="form-label">Status</label>
        <select
          class="form-select"
          v-model="phdStudy.status"
          @change="emitUpdate"
        >
          <option value="">Select Status</option>
          <option value="1">Active</option>
          <option value="2">Completed</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label">Results & Outcomes</label>
        <textarea
          class="form-control"
          rows="4"
          v-model="fellowship.resultsAndOutcomes"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, nextTick } from 'vue'

export default {
  name: 'FellowshipForm',
  props: {
    profileData: {
      type: Object,
      default: () => ({})
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    programmeLabel() {
      const map = {
        1: "EDCTP 1",
        2: "EDCTP 2"
      };

      const value = this.fellowship.programme;

      return map[value] ?? value ?? "";
    },
    callLabel() {
      const map = {
        1: "Career Development Fellowship (CDF)",
        2: "Senior Fellowship (SF)",
        3: "EDCTP Clinical Research & Development Fellowship (R&D F)",
        4: "EDCTP-AREF Preparatory Fellowships (PF)",
        5: "Senior Fellowship Plus (SFP)",
        6: "Disease Outbreak and Epidemic Response (EPI Fellows)",
        7: "Female PhD Fellowships",
        8: "EDCTP Master's Fellowship"
      };

      // Ensure key is treated as number OR string
      const key = this.fellowship.call;

      return map[key] || "";
    },
    callYearLabel() {
      const raw = this.fellowship.callDate
      if (!raw) return ''

      const parsed = new Date(raw)
      if (!isNaN(parsed.getTime())) {
        return String(parsed.getFullYear())
      }

      const rawString = String(raw)
      const yearMatch = rawString.match(/\b(19|20)\d{2}\b/)
      return yearMatch ? yearMatch[0] : rawString
    }
  },

  emits: ['update'],

  setup(props, { emit }) {
    const fellowshipId = ref(null)

    const phdDirty = ref(false)

    const internationalCountryCodes = 'AF,AX,AL,DZ,AS,AD,AO,AI,AQ,AG,AR,AM,AW,AU,AT,AZ,BS,BH,BD,BB,BY,BE,BZ,BJ,BM,BT,BO,BQ,BA,BW,BV,BR,IO,BN,BG,BF,BI,CV,KH,CM,CA,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CD,CK,CR,CI,HR,CU,CW,CY,CZ,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,SZ,ET,FK,FO,FJ,FI,FR,GF,PF,TF,GA,GM,GE,DE,GH,GI,GR,GL,GD,GP,GU,GT,GG,GN,GW,GY,HT,HM,VA,HN,HK,HU,IS,IN,ID,IR,IQ,IE,IM,IL,IT,JM,JP,JE,JO,KZ,KE,KI,KP,KR,KW,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MO,MG,MW,MY,MV,ML,MT,MH,MQ,MR,MU,YT,MX,FM,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,NC,NZ,NI,NE,NG,NU,NF,MK,MP,NO,OM,PK,PW,PS,PA,PG,PY,PE,PH,PN,PL,PT,PR,QA,RE,RO,RU,RW,BL,SH,KN,LC,MF,PM,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,SO,ZA,GS,SS,ES,LK,SD,SR,SJ,SE,CH,SY,TW,TJ,TZ,TH,TL,TG,TK,TO,TT,TN,TR,TM,TC,TV,UG,UA,AE,GB,UM,US,UY,UZ,VU,VE,VN,VG,VI,WF,EH,YE,ZM,ZW'.split(',')
    const regionNames = typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function'
      ? new Intl.DisplayNames(['en'], { type: 'region' })
      : null
    const internationalCountries = ref(
      internationalCountryCodes
        .map((value) => ({ value, label: regionNames?.of(value) || value }))
        .sort((left, right) => left.label.localeCompare(right.label))
    )

    const africanCountries = ref([
      { value: 'DZ', label: 'Algeria' },
      { value: 'AO', label: 'Angola' },
      { value: 'BJ', label: 'Benin' },
      { value: 'BW', label: 'Botswana' },
      { value: 'BF', label: 'Burkina Faso' },
      { value: 'BI', label: 'Burundi' },
      { value: 'CM', label: 'Cameroon' },
      { value: 'CV', label: 'Cape Verde' },
      { value: 'CF', label: 'Central African Republic' },
      { value: 'TD', label: 'Chad' },
      { value: 'KM', label: 'Comoros' },
      { value: 'CG', label: 'Congo' },
      { value: 'CD', label: 'Democratic Republic of Congo' },
      { value: 'DJ', label: 'Djibouti' },
      { value: 'EG', label: 'Egypt' },
      { value: 'GQ', label: 'Equatorial Guinea' },
      { value: 'ER', label: 'Eritrea' },
      { value: 'SZ', label: 'Eswatini' },
      { value: 'ET', label: 'Ethiopia' },
      { value: 'GA', label: 'Gabon' },
      { value: 'GM', label: 'Gambia' },
      { value: 'GH', label: 'Ghana' },
      { value: 'GN', label: 'Guinea' },
      { value: 'GW', label: 'Guinea-Bissau' },
      { value: 'CI', label: 'Ivory Coast' },
      { value: 'KE', label: 'Kenya' },
      { value: 'LS', label: 'Lesotho' },
      { value: 'LR', label: 'Liberia' },
      { value: 'LY', label: 'Libya' },
      { value: 'MG', label: 'Madagascar' },
      { value: 'MW', label: 'Malawi' },
      { value: 'ML', label: 'Mali' },
      { value: 'MR', label: 'Mauritania' },
      { value: 'MU', label: 'Mauritius' },
      { value: 'MA', label: 'Morocco' },
      { value: 'MZ', label: 'Mozambique' },
      { value: 'NA', label: 'Namibia' },
      { value: 'NE', label: 'Niger' },
      { value: 'NG', label: 'Nigeria' },
      { value: 'RW', label: 'Rwanda' },
      { value: 'ST', label: 'São Tomé and Príncipe' },
      { value: 'SN', label: 'Senegal' },
      { value: 'SC', label: 'Seychelles' },
      { value: 'SL', label: 'Sierra Leone' },
      { value: 'SO', label: 'Somalia' },
      { value: 'ZA', label: 'South Africa' },
      { value: 'SS', label: 'South Sudan' },
      { value: 'SD', label: 'Sudan' },
      { value: 'TZ', label: 'Tanzania' },
      { value: 'TG', label: 'Togo' },
      { value: 'TN', label: 'Tunisia' },
      { value: 'UG', label: 'Uganda' },
      { value: 'ZM', label: 'Zambia' },
      { value: 'ZW', label: 'Zimbabwe' }
    ])

    // ---------- LOCAL STATE ----------
    const fellowship = ref({
      fellow: '',
      gender: '',
      programme: '',
      call: '',
      callDate: '',
      title: '',
      projectCode: '',
      startDate: '',
      endDate: '',
      objectives: '',
      studyDesign: '',
      projectSummary: '',
      resultsAndOutcomes: ''
    })

    const collaborators = ref([{ department: '', institution: '', country: '' }])
    const participants = ref([{ department: '', institution: '', country: '' }])
    const students = ref([{
      type: '', name: '', title: '', country: '', university: '', startDate: '', endDate: ''
    }])
    const sites = ref([{ name: '' }])

    const phdStudy = ref({
      title: '',
      university: '',
      startDate: '',
      endDate: ''
    })

    const isInitializing = ref(false)
    let debounceTimer = null

    const formatDate = (value) => {
      if (!value) return ''
      const d = new Date(value)
      return isNaN(d.getTime()) ? '' : d.toISOString().split('T')[0]
    }

    const normaliseArray = (arr, emptyTemplate) => {
      if (!Array.isArray(arr)) {
        return [{ ...emptyTemplate }]
      }

      const cleaned = arr
        .filter(item => item && typeof item === 'object')
        .map(item => ({ ...emptyTemplate, ...item }))
        .filter(item =>
          Object.values(item ?? {}).some(
            v => v !== '' && v !== null && v !== undefined
          )
        )

      return cleaned.length ? cleaned : [{ ...emptyTemplate }]
    }

    // ---------- SYNC FROM PARENT ----------
    const syncFromProps = async (newVal) => {
      fellowshipId.value = newVal.fellowship_id || null

      if (!newVal) return

      isInitializing.value = true

      const userName =
        props.profileData?.user?.name ||
        props.profileData?.personal?.fullName ||
        props.profileData?.name ||
        newVal?.fellow ||
        ''

      fellowship.value = {
        fellow: userName,
        gender: newVal.gender || '',
        programme: newVal.programme || '',
        call: newVal.call || '',
        callDate: formatDate(newVal.callDate),
        title: newVal.title || '',
        projectCode: newVal.projectCode || newVal.edctp_project_code || newVal.edctp_project || '',
        startDate: formatDate(newVal.startDate),
        endDate: formatDate(newVal.endDate),
        objectives: newVal.objectives || '',
        studyDesign: newVal.studyDesign || '',
        projectSummary: newVal.projectSummary || '',
        resultsAndOutcomes: newVal.resultsAndOutcomes || ''
      }

      // Collaborators
      const incoming = normaliseArray(newVal.collaborators, {
        department: '', institution: '', country: ''
      })

      if (incoming.length >= collaborators.value.length) {
        collaborators.value = incoming
      }

      // Participants
      const incomingParticipants = normaliseArray(newVal.participants, {
        department: '', institution: '', country: ''
      })
      if (incomingParticipants.length >= participants.value.length) {
        participants.value = incomingParticipants
      }

      // Students
      const incomingStudents = normaliseArray(newVal.students, {
        type: '', name: '', title: '', country: '', university: '', startDate: '', endDate: ''
      })
      if (incomingStudents.length >= students.value.length) {
        students.value = incomingStudents
      }

      // Sites
      const incomingSites = normaliseArray(newVal.sites, { name: '' })
      if (incomingSites.length) {
        sites.value = incomingSites
      }

      const phdArray = newVal.phdStudy || newVal.phd_study || []

      const phdSource = Array.isArray(phdArray) && phdArray.length
        ? phdArray[0]
        : {}

      // ⛔ DO NOT overwrite PhD while user is editing
      if (phdDirty.value) return

      phdStudy.value = {
        title: phdSource.title || '',
        university: phdSource.university || '',
        startDate: formatDate(phdSource.startDate ?? phdSource.start_date),
        endDate: formatDate(phdSource.endDate ?? phdSource.end_date),
        subjects: phdSource.subjects || '',
        status: phdSource.status || '',
        results: phdSource.results || ''
      }

      await nextTick()
      isInitializing.value = false
    }

    watch(
      () => props.formData,
      (newVal) => {
        console.log('📥 FellowshipForm received formData:', newVal)
        console.log('📥 phdStudy raw:', newVal?.phdStudy)
        syncFromProps(newVal)
      },
      { immediate: true }
    )

    // ---------- EMIT TO PARENT ----------
    const emitUpdate = () => {
      if (isInitializing.value) return

      if (debounceTimer) clearTimeout(debounceTimer)

      debounceTimer = setTimeout(() => {
        const filterEmpty = (arr) =>
          arr.filter((item) =>
            Object.values(item ?? {}).some(
              (v) => v !== '' && v !== null && v !== undefined
            )
          )

        const hasPhDData = Object.values(phdStudy.value).some(
          (v) => v !== '' && v !== null && v !== undefined
        )

        const payload = {
          fellowship: {
            fellowship_id: fellowshipId.value,
            fellow: fellowship.value.fellow || '',
            gender: fellowship.value.gender || '',
            programme: fellowship.value.programme || '',
            call: fellowship.value.call || '',
            callDate: fellowship.value.callDate || '',
            title: fellowship.value.title || '',
            projectCode: fellowship.value.projectCode || '',
            startDate: fellowship.value.startDate || '',
            endDate: fellowship.value.endDate || '',
            objectives: fellowship.value.objectives || '',
            studyDesign: fellowship.value.studyDesign || '',
            projectSummary: fellowship.value.projectSummary || '',
            collaborators: filterEmpty(collaborators.value),
            participants: filterEmpty(participants.value),
            students: filterEmpty(students.value),
            sites: filterEmpty(sites.value),
            resultsAndOutcomes: fellowship.value.resultsAndOutcomes,
            phd_study: hasPhDData
              ? [{
                title: phdStudy.value.title,
                university: phdStudy.value.university,
                startDate: phdStudy.value.startDate,
                endDate: phdStudy.value.endDate,
                subjects: phdStudy.value.subjects,
                status: phdStudy.value.status // "1" or "2"
              }]
              : []
          }
        }
        console.log('🚨 EMIT PAYLOAD', JSON.parse(JSON.stringify(payload)))

        emit('update', payload)
      }, 250)
    }

    // ---------- ARRAY HELPERS ----------
    const addCollaborator = () => {
      collaborators.value.push({ department: '', institution: '', country: '' })
      emitUpdate()
    }

    const removeCollaborator = (index) => {
      if (collaborators.value.length > 1) {
        collaborators.value.splice(index, 1)
        emitUpdate()
      }
    }

    const addParticipant = () => {
      participants.value.push({ department: '', institution: '', country: '' })
      emitUpdate()
    }

    const removeParticipant = (index) => {
      if (participants.value.length > 1) {
        participants.value.splice(index, 1)
        emitUpdate()
      }
    }

    const addStudent = () => {
      students.value.push({
        type: '', name: '', title: '', country: '', university: '', startDate: '', endDate: ''
      })
      emitUpdate()
    }

    const removeStudent = (index) => {
      if (students.value.length > 1) {
        students.value.splice(index, 1)
        emitUpdate()
      }
    }

    const addSite = () => {
      sites.value.push({ name: '' })
      emitUpdate()
    }

    const removeSite = (index) => {
      if (sites.value.length > 1) {
        sites.value.splice(index, 1)
        emitUpdate()
      }
    }

    return {
      fellowship,
      collaborators,
      participants,
      students,
      sites,
      phdStudy,
      internationalCountries,
      africanCountries,
      emitUpdate,
      addCollaborator,
      removeCollaborator,
      addParticipant,
      removeParticipant,
      addStudent,
      removeStudent,
      addSite,
      removeSite
    }
  }
}
</script>

<style scoped>
.form-step {
  min-height: 400px;
}

.section-header {
  margin: 2rem 0 1.5rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #17a2b8;
}

.section-title {
  color: #17a2b8;
  font-weight: 600;
  font-size: 1.1rem;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
}

.form-control,
.form-select {
  border-radius: 6px;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus,
.form-select:focus {
  border-color: #17a2b8;
  box-shadow: 0 0 0;
}
</style>
